import { render, staticRenderFns } from "./FlavorPondRow.vue?vue&type=template&id=5ed622a6&scoped=true"
import script from "./FlavorPondRow.vue?vue&type=script&lang=js"
export * from "./FlavorPondRow.vue?vue&type=script&lang=js"
import style0 from "./FlavorPondRow.vue?vue&type=style&index=0&id=5ed622a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed622a6",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QIcon,QDialog});
